/*=========================================================================================
  File Name: moduleCategoryMutations.js
  Description: Category Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_OPTIMIZER_MANAGER(state, item) {
		state.optimizerManagerList.unshift(item);
	},
	SET_OPTIMIZER_MANAGER(state, items) {
		state.optimizerManagerList = [...items];
	},
	UPDATE_OPTIMIZER_MANAGER(state, visitPoint) {
		const visitPointIndex = state.optimizerManagerList.findIndex((p) => p.id === visitPoint.id);
		if (visitPointIndex !== -1) {
			Object.assign(state.optimizerManagerList[visitPointIndex], visitPoint);
		}
	},
	REMOVE_OPTIMIZER_MANAGER(state, itemId) {
		const ItemIndex = state.optimizerManagerList.findIndex((p) => p.id === itemId);
		state.optimizerManagerList.splice(ItemIndex, 1);
	},
};
